import AxiosAPI from '../../utils/AxiosAPI';

// User Registration Form Handler
export const handleUserRegOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/auth/create-account`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// User Login Form Handler
export const handleUserLogInOpe = (formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/auth/login`)
            .post({ ...formData, role: 'admin' })
            .then(({ data }) => {
                resolve(data);
            })
            .catch((err) => {
                reject(err);
            });
    });

// User Forgot Password Form Handler
export const handleSendOptOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/auth/forget-password/verify-identity`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// User Forgot Password OTP Handler
export const handleVerifyOtpOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/auth/forget-password/verify-code`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// User Create new Password Handler
export const handleUpdatePasswordOpe = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/auth/forget-password/update-password`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName || '');
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export const handleUserLogOutOpe = (token) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/auth/logout`)
            .post({ token })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data?.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
